import isObject from 'lodash-es/isObject'
import * as Yup from 'yup'

import { EMPTY_OBJECT } from '../../constants/common'
import i18n from '../../i18n'
import { isValueStringType } from '../../utils/common'

/**
 * Check is select value valid, `value.value` must be number to pass
 * By default all selects should have `value` prop as number type
 */
function checkFormikFormSelectFieldWithCreationValidObjectValue(value) {
  return isObject(value) && Number.isFinite(value.value)
}

export function getFormikFormFieldErrorProps(error) {
  return { error }
}

export function getFormikWysiwygErrorProps(error) {
  return { error }
}

// #TODO `describe` Should be imporved with context and this
// method should replace checks for empty required fields in future.
export function getFormikRequiredFields(schema) {
  const fields = schema.describe().fields

  return Object.entries(fields).reduce((acc, [key, schemaDescription]) => {
    if (!schemaDescription.optional) {
      return [...acc, key]
    }

    return acc
  }, [])
}

export function hasFormikFormEmptyRequired(errors) {
  return Object.values(errors).includes(true)
}

export function getFormikFormSelectFieldValidationSchema({
  notSelectedValueErrorText,
  objectPK = 'value',
  required,
} = EMPTY_OBJECT) {
  return Yup.lazy(value => {
    if (isValueStringType(value)) {
      return Yup.object().typeError(notSelectedValueErrorText)
    }

    return Yup.object({
      [objectPK]: required ? Yup.number().required(true) : Yup.number(),
    }).required(required ? true : undefined)
  })
}

export function getFormikFormSelectFieldWithCreationValidationSchema({
  checkIsValidObjectValue = checkFormikFormSelectFieldWithCreationValidObjectValue,
  maxLength,
  message = true,
  required,
} = EMPTY_OBJECT) {
  return Yup.lazy(value => {
    const isString =
      isValueStringType(value) || value === null || value === undefined

    if (isString) {
      let schema = Yup.string().nullable()

      if (maxLength) {
        schema = schema.max(
          maxLength,
          i18n.t('Error.MaxLengthKey', { length: maxLength })
        )
      }

      if (required) {
        schema = schema.required(true)
      }

      return schema
    }

    let schema = Yup.object().test({
      message,
      name: 'is-valid-select-with-creation-value',
      test: checkIsValidObjectValue,
    })

    if (required) {
      schema = schema.required(true)
    }

    return schema
  })
}

// A select whose Formik value is the plain option value, not the option object
export function getFormikSelectFieldValueProps(options) {
  return field => ({
    value: options.find(option => option.value === field.value) ?? null,
  })
}

export function getFormikSelectFieldNextValue(option) {
  return option?.value ?? null
}

export function getFormikMultiSelectFieldValueProps(options) {
  return field => ({
    value: options.filter(option => field.value.includes(option.value)),
  })
}

export function getFormikMultiSelectFieldNextValue(options) {
  return options.map(option => option.value)
}
